import React, { useMemo } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";

import MDContainer from "@material-ui/core/Container";
import { CardContent } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { usePictureSets } from "../../../hooks/usePictureSets";

import styled from "styled-components";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Link } from "react-router-dom";
import EpmsImage from "../../../../components/Common/EpmsImage";
import AppBar from "../../Components/AppBar";
import useRoutes from "../../../hooks/useRoutes";

const StyledPictureList = styled.ul`
  margin: 0;
  margin-top: 16px;
  padding: 0;
  list-style: none;
  width: 100%;
  max-height: 45vw;
  overflow: hidden;
  box-sizing: border-box;

  > li {
    width: 30%;
    display: inline-block;
    margin-right: 5%;
    margin-bottom: 5%;
    height: 0;
    padding-bottom: 30%;
    position: relative;

    > img {
      position: absolute;
      width: 100%;
      height: 100%;

      object-fit: cover;
    }
  }

  > li:nth-child(3n) {
    margin-right: 0;
  }
`;

const Year = styled.div`
  font-size: 16px;
`;

const SubjectName = styled.h4`
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`;

const JobName = styled.h5`
  lineheight: 24px;
  font-size: 16px;
  margin: 0;
  font-weight: 400;
`;

const useStyles = makeStyles({
  card: {
    marginBottom: "8px",
  },
  pictureLContent: {},
  actionsContainer: {
    justifyContent: "space-between",
  },
});

export default () => {
  const { isLoaded, pictureSets } = usePictureSets();
  const classes = useStyles();
  const routes = useRoutes();

  if (!isLoaded) {
    return <div>Loading</div>;
  }

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Picture sets</Trans>
      </PageHeader>
      <MDContainer>
        {pictureSets.map((pictureSet) => {
          console.log("Rendering picture set", pictureSet);
          const boughtAtLeastOnePicture =
            pictureSet.bought ||
            pictureSet.pictures.some((picture) => picture.bought);

          const createdDate = new Date(0);
          createdDate.setUTCSeconds(pictureSet.job.creationTime);
          const year = createdDate.getFullYear();

          return (
            <Card className={classes.card} key={pictureSet.subject.uuid}>
              <CardContent className={classes.cardContent}>
                <Year>{year}</Year>
                <SubjectName>{pictureSet.subject.name}</SubjectName>
                <JobName>{pictureSet.job.name}</JobName>
                <StyledPictureList>
                  {pictureSet.pictures.slice(0, 7).map((picture) => {
                    console.log(
                      "Rendering the first pictures of",
                      pictureSet.pictures,
                    );
                    return (
                      <li key={picture.uuid}>
                        <EpmsImage uuid={picture.uuid} />
                      </li>
                    );
                  })}
                </StyledPictureList>
              </CardContent>
              <CardActions classes={{ root: classes.actionsContainer }}>
                <Button
                  size="small"
                  component={Link}
                  color="primary"
                  to={`/my-account/picture-sets/${pictureSet.subject.uuid}`}
                >
                  {boughtAtLeastOnePicture ? (
                    <Trans>View and download</Trans>
                  ) : (
                    <Trans>View</Trans>
                  )}
                </Button>
                <Button
                  size="small"
                  component={Link}
                  color="primary"
                  to={routes["products.list"].path}
                >
                  <Trans>Buy products</Trans>
                </Button>
              </CardActions>
            </Card>
          );
        })}
      </MDContainer>
    </MobilePage>
  );
};
